export default "__VITE_ASSET__D91u5dpb__"